import request from '@/middleware/request'

const listFlowLog = (id, data) => {
  return request({
    url: `/flow_log/list/${id}`,
    method: 'post',
    data
  })
}

const getFlowLog = id => {
  return request({
    url: `/flow_log/${id}`,
    method: 'get'
  })
}

const updateFlowLog = (id, data) => {
  return request({
    url: `/flow_log/${id}`,
    method: 'patch',
    data
  })
}

export default {
  listFlowLog,
  getFlowLog,
  updateFlowLog
}
